import React from 'react';
import { Tooltip } from '@mui/material';

interface Props {
  /** Exibido quando `disabled` é true. */
  title: string;
  disabled: boolean;
  children: React.ReactElement;
}

/**
 * MUI Tooltip não dispara em botões `disabled` — envolve em `<span>` quando necessário.
 * Reutilizável em filtros e ações com pré-condições.
 */
export function TooltipWhenDisabled({ title, disabled, children }: Props) {
  if (!disabled || !title.trim()) {
    return children;
  }
  return (
    <Tooltip title={title} arrow>
      <span style={{ display: 'inline-flex' }}>{children}</span>
    </Tooltip>
  );
}

export default TooltipWhenDisabled;
